import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import TechForTheModernChef from "./sections/TechForTheModernChef";
import LetsCollaborate from "./sections/LetsCollaborate";
import FindingYourWay from "./sections/FindingYourWay";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <TechForTheModernChef />
      <LetsCollaborate />
      <FindingYourWay />
      <Footer />
    </div>;
}